const REFRESH_TOKEN = "refresh_token";

function readFromCookie() {
  if (!globalThis.document) return undefined;
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith(REFRESH_TOKEN))
    ?.split("=")[1];
}

function deleteFromCookie() {
  if (!globalThis.document) return;
  document.cookie = `${REFRESH_TOKEN}=; path=/; max-age=0`;
}

export const getLegacyRefreshToken: () => string = () => {
  const defaultValue = "";
  try {
    return (
      readFromCookie() || localStorage.getItem(REFRESH_TOKEN) || defaultValue
    );
  } catch (e) {
    console.error(e);
    return defaultValue;
  }
};

export const deleteLegacyRefreshToken = () => {
  try {
    deleteFromCookie();
    return localStorage.removeItem(REFRESH_TOKEN);
  } catch (e) {
    console.error(e);
  }
};
